import React, { useState, memo } from "react";
import { StyleSheet, View } from "react-native";

import CustomButton from "../../common/general/CustomButton/CustomButton";
import FilterDropdown from "../../common/TableControls/FilterDropdown";
import { AudienceType, ActivityState } from "@axio/graphql/generated/graphql";

export type ActivityFilter = "all" | ActivityState;
export type AudienceFilter = "all" | AudienceType;

interface AnnouncementFiltersProps {
  activeFilter: ActivityFilter;
  onFilterChange: (filter: ActivityFilter) => void;
  targetAudience: AudienceFilter;
  onTargetAudienceChange: (audience: AudienceFilter) => void;
}

const filterTabs: { value: ActivityFilter; label: string }[] = [
  { value: "all", label: "All Announcements" },
  { value: ActivityState.Published, label: "Published" },
  { value: ActivityState.Scheduled, label: "Scheduled" },
  { value: ActivityState.Draft, label: "Drafts" },
];

const targetAudienceOptions: { value: AudienceFilter; label: string }[] = [
  { value: "all", label: "All Audiences" },
  { value: AudienceType.School, label: "Schoolwide" },
  { value: AudienceType.Students, label: "All Students" },
  { value: AudienceType.Faculty, label: "All Faculty" },
  { value: AudienceType.SpecificGroups, label: "Specific Groups" },
];

const AnnouncementFilters: React.FC<AnnouncementFiltersProps> = ({
  activeFilter,
  onFilterChange,
  targetAudience,
  onTargetAudienceChange,
}) => {
  const [targetDropdownOpen, setTargetDropdownOpen] = useState(false);

  return (
    <View style={styles.container}>
      {/* Filter Tabs */}
      <View style={styles.filterTabs}>
        {filterTabs.map((tab) => (
          <CustomButton
            key={tab.value}
            text={tab.label}
            size="s"
            styleType={activeFilter === tab.value ? "primary" : "transparent"}
            onPress={() => onFilterChange(tab.value)}
            style={styles.filterTab}
            textStyle={[styles.filterTabText, activeFilter === tab.value && styles.activeFilterTabText]}
          />
        ))}
      </View>

      {/* Filter Controls */}
      <View style={styles.filterControls}>
        <View style={styles.filterGroup}>
          <FilterDropdown
            filterValue={targetAudience}
            setFilterValue={onTargetAudienceChange}
            filterDropdownOpen={targetDropdownOpen}
            setFilterDropdownOpen={setTargetDropdownOpen}
            filterItems={targetAudienceOptions}
            label="target_audience"
            placeholder="All Audiences"
          />
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingBottom: 16,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottomWidth: 1,
    borderBottomColor: "#E5E7EB",
    zIndex: 10,
  },
  filterTabs: {
    flexDirection: "row",
    gap: 8,
  },
  filterTab: {
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderRadius: 6,
  },
  filterTabText: {
    color: "#475467",
    fontSize: 14,
    fontWeight: "500",
  },
  activeFilterTabText: {
    color: "#FFFFFF",
  },
  filterControls: {
    flexDirection: "row",
    alignItems: "center",
    gap: 16,
    zIndex: 10,
  },
  filterGroup: {
    flexDirection: "row",
    alignItems: "center",
    gap: 8,
  },
});

export default AnnouncementFilters;
